export const tokens = {
  colors: {
    primary: '#F78E1E',
    primaryHover: '#DA7408',
    primaryLight: '#E8F5E9',
    secondaryHover: '#F9A44C',
    text: '#263238',
    background: '#FFFFFF',
    backgroundHover: '#F5F5F5',
    border: '#D9D9D9',
    menuBackground: '#FFFFFF',
    menuText: '#000000',
    menuItemSelectedBg: '#FFF9EB',
    secondaryText: '#ab4f03',
  },
  typography: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 13,
    lineHeight: 1.2,
    fontWeights: {
      regular: 400,
      medium: 500,
      bold: 700,
    },
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
  },
} as const;

export type ITokensType = typeof tokens;
